import { KendoBaseComponent, KendoBaseInputComponent } from '@progress/kendo-base-components-vue-wrapper'
import TimePickerProps from './TimePickerProps'

import Animation from '../Common/Animation'

export default {
    props: TimePickerProps,
    emits: {
        'update:modelValue': null,
        'kendowidgetready': null
    },
    mixins: [
        KendoBaseComponent,
        KendoBaseInputComponent,
        Animation
    ],
    mounted() {
        var that = this
        kendo.jQuery(that.$el).kendoTimePicker(that.widgetOptions)
        var widget = that.kendoWidget()

        if(this.v3) {
            this.ready()
            this.$emit('kendowidgetready', widget)
        } else {
            this.$emit('kendowidgetready', widget)
        }

        that.kendoWidget().bind('change', function () {
            if(that.v3){
                that.$emit('update:modelValue', widget.value())
            } else {
                that.$emit('changemodel', widget.value())
            }
        })
    },
    methods: {
        kendoWidget() {
            return kendo.jQuery(this.$el).getKendoTimePicker()
        }
    }
}


// WEBPACK FOOTER //
// ./packages/kendo-dateinputs-vue-wrapper/src/KendoTimePicker/KendoTimePickerMixin.js